import React from 'react';
import styled from 'styled-components';
import { StyledProps } from '../../util/styled-types';

// TODO: Refactor to allow icon to be string for local icon
interface MenuButtonProps {
  onClick: (...props: any) => any;
  Icon: any,
  style?: any
}
export const MenuButton = ({ onClick, Icon, style }: MenuButtonProps) => {
  return (
    <Container onClick={onClick} style={style ?? {}}>
      <Icon style={{ fontSize: '1.4rem'}} />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  width: 2.5rem;
  height: 2.5rem;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }: StyledProps) => theme.colors.menu.background};
  box-shadow: 1px 1px 2px 2px #0000001d;
  border-radius: 32px;
  cursor: pointer;
  :hover {
    background-color: ${({ theme }: StyledProps) => theme.colors.menu.background_light};
  }
  :active {
    background-color: ${({ theme }: StyledProps) => theme.colors.menu.background};
  }
`;

export default MenuButton;